import { InjectionToken } from '@angular/core';

/**
 * Token used for providing the IDynamicFormModuleConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: DynamicFormModuleConfigToken, useValue: dynamicFormModuleConfig },
 * ],
 */
const DynamicFormModuleConfigToken = new InjectionToken('dynamic_form_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { DynamicFormModuleConfigToken };

//# sourceMappingURL=mt-ng2-dynamic-form-config.js.map